






























































































































import BaseComponent from '@/core/base.component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import companyDistrictService from '@/services/company-district.service';
import amenityService from '@/services/amenity.service';
import { SpaceTypeDto, SpaceTypePatchDto } from '@/dto/company-district';
import { AmenityDto } from '@/dto/amenity/amenity.dto';
import { ContractDto } from '@/dto/contract/contract.dto';
import { ContractSearchDto } from '@/dto/contract/contract-search.dto';
import contractService from '@/services/contract.service';
import { Pagination } from '@/core';

@Component({
  name: 'SpaceTypeDetailDialog',
})
export default class SpaceTypeDetailDialog extends BaseComponent {
  @Prop({ required: true }) readonly dialog: boolean;
  @Prop() readonly spaceTypeNo: number;
  @Prop({ default: false }) readonly readonly: boolean;

  private spaceTypeDto = new SpaceTypeDto();
  private spacePatchDto = new SpaceTypePatchDto();
  private kitchenFacilityList: AmenityDto[] = [];
  private loading = false;
  private patchLoading = false;
  private amenityArr = [];

  // 계약 리스트
  private contractDtoList: ContractDto[] = [];
  private contractSearchDto = new ContractSearchDto();
  private contractListCount = null;
  private pagination = new Pagination();

  private headers = [
    {
      text: '지점명',
      value: 'deliverySpace.companyDistrict.nameKr',
      align: 'center',
    },
    {
      text: '공간타입',
      value: 'deliverySpace.typeName',
      align: 'center',
    },
    {
      text: '계약자',
      value: 'nanudaUser.name',
      align: 'center',
    },
    {
      text: '생성일',
      value: 'createdAt',
      align: 'center',
    },
  ];

  @Watch('dialog')
  dialogChanged() {
    if (this.dialog) {
      this.getSpaceType();
      this.getContractList();
    }
  }

  toggle() {
    this.$emit('update:dialog', !this.dialog);
    this.reset();
  }
  patch() {
    this.patchLoading = true;
    this.spacePatchDto = this.spaceTypeDto;
    this.spacePatchDto.amenityIds = this.amenityArr;
    companyDistrictService
      .patchDistrictSpaceType(this.spaceTypeNo, this.spacePatchDto)
      .subscribe(res => {
        this.patchLoading = false;
        this.$toasted.global.custom_success({ message: '수정 완료!' });
        this.toggle();
        this.$emit('patched');
      });
  }
  getSpaceType() {
    this.loading = true;
    companyDistrictService
      .findDistrictSpaceType(this.spaceTypeNo)
      .subscribe(res => {
        this.spaceTypeDto = res.data;
        this.amenityArr = res.data.amenities.map(e => {
          return e.no;
        });
        this.spacePatchDto.deliverySpaceOptionIds =
          res.data.deliverySpaceOptions;
        this.loading = false;
      });
  }
  getAmenityList() {
    amenityService.findkitchenFacility().subscribe(res => {
      this.kitchenFacilityList = res.data;
    });
  }

  // 타입별 계약 리스트
  getContractList() {
    this.contractSearchDto.deliverySpaceNo = this.spaceTypeNo;
    contractService
      .findAll(this.contractSearchDto, this.pagination)
      .subscribe(res => {
        if (res) {
          this.contractDtoList = res.data.items;
          this.contractListCount = res.data.totalCount;
        }
      });
  }
  // 타입별 계약 리스트 상세 보기
  toSelectedItemPage(value) {
    this.$router.push(`/contract/${value.no}`);
  }

  reset() {
    this.spaceTypeDto = new SpaceTypeDto();
    this.spacePatchDto = new SpaceTypePatchDto();
    this.contractDtoList = [];
    this.amenityArr = [];
  }
  created() {
    this.getSpaceType();
    this.getAmenityList();
    this.getContractList();
  }
}
